import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ComentariosService } from '../../services/comentarios.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { isNil } from 'lodash';
import { ComentarioProfessorModel, ProfessorModel } from '../../models/professor.model';
import { NgxHotjarService } from 'ngx-hotjar';
import { AlunosModel } from '../../alunos/alunos.model';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-comentarios-professor',
  templateUrl: './comentarios-professor.component.html',
  styleUrls: ['./comentarios-professor.component.scss']
})
export class ComentariosProfessorComponent implements OnInit {

  constructor(
    private comentarioService: ComentariosService,
    public loaderService: LoaderService,
    private hotjar: NgxHotjarService,
  ) {
    this.Initialize();

    this.inputSubject.pipe(debounceTime(500)).subscribe(value => {
      if (value !== this.ultimoTexto) {
        this.comentarioTexto.emit(value);
        this.ultimoTexto = value;
      }
    });

   }

  ngOnInit(): void {
    this.Initialize();
  }

  _comentario: string;
  _disabled: boolean;
  _professor: ProfessorModel;
  _aluno: AlunosModel;
  _reavaliado: boolean;

  salvo = false;
  comentariosend = true;

  @Input()
  set professor(value: ProfessorModel) {
    this._professor = value;
    this.Initialize();

    let textarea = document.querySelectorAll('textarea')[0];

    if(textarea) {
      textarea.value = this.professor.comentario;
    }
  }
  get professor(): ProfessorModel {
    return this._professor;
  }

  @Input()
  set aluno(value: AlunosModel) {
    this._aluno = value;
  }
  get aluno(): AlunosModel {
    return this._aluno;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
    this._disabled ? this.salvo = true : this.salvo = false;
  }
  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set reavaliado(value: boolean) { this._reavaliado = value }
  get reavaliado() {return this._reavaliado}

  @Output() reavaliadoFeedback = new EventEmitter<boolean>();

  emitterReavaliadoFeedback() {
    this.reavaliadoFeedback.emit(true);
  }

  @Input() comentarioProfessor: string = '';
  @Output() comentarioFeedback = new EventEmitter();

  @Output() respostaEnviada = new EventEmitter<boolean>();
  @Output() exibirListaProfessores = new EventEmitter<boolean>();

  @Output() comentarioTexto = new EventEmitter<string>();
  private inputSubject = new Subject<string>();

  comentario: string = '';
  ultimoTexto: string = '';

  emitterRespotaEnviada() {
    this.respostaEnviada.emit(true);
  }

  emitterExibirListaProfessores() {
    this.exibirListaProfessores.emit(true);
  }

  @ViewChild('myTextArea') myTextArea: ElementRef;

  Initialize(): void {
    this.salvo = false;
    this.comentariosend = false;
    this.disabled ? this.salvo = true : this.salvo = false;
  }

  isNovoComentário: boolean = false;
  detectChange(value: string) {
    this.isNovoComentário= true;
  }

  change(x: string = "") {
    this.comentarioProfessor = x;
    this.salvo = false;

    if(x.length)
      this.comentariosend = false;
    else
      this.comentariosend = true;

    this.comentario = x;
    this.emitterReavaliadoFeedback();
    this.inputSubject.next(this.comentario);
  }

  salvar() {
    const comentarioProfessor = this.comentarioProfessor;
    const hashProfessor = this.professor.id;
    const hashPessoa = this.aluno.hashPessoa;

    const hashs = {
      hashProfessor,
      hashPessoa,
      comentarioProfessor,
    };

    if (this.comentarioProfessor != null && this.comentarioProfessor.length && this.salvo == false) {
      if (!isNil(this.comentarioProfessor)) {
        this.comentariosend = true;
        this.loaderService.show();

        this.comentarioService
          .salvarComentario(hashs)
          .subscribe(
            () => {
              this.salvo = true;
              this.comentariosend = true;
              this.loaderService.hide();
              this.emitterRespotaEnviada();
              this.emitterExibirListaProfessores();
              hashs['comentariosend'] = true;
              this.comentarioFeedback.emit(hashs);
              this.emitterReavaliadoFeedback();
            },
            () => {
              this.comentariosend = false;
              this.loaderService.hide();
            }
          );
      }
    } else {
      this.emitterRespotaEnviada();
      this.emitterReavaliadoFeedback();
    }

  }

  isNumeric(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  cancelar(){
    this.emitterExibirListaProfessores();
  }

}
